module.exports = __webpack_public_path__ + "static/img/19.03c8b99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/19.jpg
// module id = jlSo
// module chunks = 1